import React from 'react'
import { Link } from 'react-router-dom'

function Card(props) {
    return (

        <div className={`col-xl-${props.size} col-lg-${props.size} col-md-${props.size+2} mb-${props.size}`}>
            <div className="card light-blue lighten-5 card-stats mt-5 mb-3">
                <Link to={props.redirect}>
                    <div className="card-header card-header-icon">
                        <div className="card-icon blue z-depth-1-half waves-effect">
                            <i className={props.icon} />
                        </div>
                        <p className="card-category" style={{fontWeight:600}}>{props.title}</p>
                        {/* <h3 className="card-title">0 </h3> */}
                    </div>
                    <div className="card-footer">
                        <div className="stats">
                            <p>Get More Info...</p>
                        </div>
                    </div>
                </Link>
            </div>
        </div>

    )
}

export default Card
